import designItem from './DesignTableColumn.vue'
const DesignTableColumn = {
  install: function (Vue) {
    Vue.component('DesignTableColumn', designItem)
  }
}
export default DesignTableColumn
